/* eslint import/no-webpack-loader-syntax: "off" */
require('expose-loader?Global!../utils/global.js')
